// 26.1.8 Reflect.getPrototypeOf(target)
var $export  = require(32)
  , getProto = require(74)
  , anObject = require(7);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target){
    return getProto(anObject(target));
  }
});